import { jsx } from "react/jsx-runtime";
import { alignToFlexAlign } from "../../utils/align.mjs";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const Stack = ({
  component = "div",
  children,
  space = "none",
  align: alignProp,
  data,
  ...restProps
}) => {
  const align = alignProp || "left";
  return /* @__PURE__ */ jsx(
    Box,
    {
      component,
      display: "flex",
      flexDirection: "column",
      gap: space,
      alignItems: align !== "left" ? alignToFlexAlign(align) : void 0,
      textAlign: alignProp,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  );
};
export {
  Stack
};
